import { render } from "./AttachTeam.vue?vue&type=template&id=0a9a1635"
import script from "./AttachTeam.vue?vue&type=script&lang=js"
export * from "./AttachTeam.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__